import { render, staticRenderFns } from "./CommonBookMarkPopup.vue?vue&type=template&id=94962324&scoped=true&"
import script from "./CommonBookMarkPopup.vue?vue&type=script&lang=js&"
export * from "./CommonBookMarkPopup.vue?vue&type=script&lang=js&"
import style0 from "./CommonBookMarkPopup.vue?vue&type=style&index=0&id=94962324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94962324",
  null
  
)

export default component.exports